<template>
  <AdminAssetTable :config="memosConfig" :items="memosData" :users="users" :api-service="memosApiService"
    @refresh="loadMemos" />
</template>

<script setup lang="ts">
import { memos } from '@/api/memos';
import type { User } from '@/api/types/core/users';
import type { Memo } from '@/api/types/memos/types';
import { fetchAllUsers } from '@/api/users';
import AdminAssetTable from '@/components/admin/AdminAssetTable.vue';
import { ADMIN_ASSET_CONFIGS } from '@/configs/adminAssetConfigs';
import { onMounted, ref } from 'vue';

// Configuration
const memosConfig = ADMIN_ASSET_CONFIGS.memos;

// État
const memosData = ref<Memo[]>([]);
const users = ref<User[]>([]);
const loading = ref(false);

// Service API adapté au format attendu par AdminAssetTable
const memosApiService = {
  async getAll(): Promise<Memo[]> {
    return await memos.getAllAdminWithDeleted();
  },

  async create(data: Record<string, unknown>): Promise<Memo> {
    return await memos.createMemo(data as any);
  },

  async update(uuid: string, data: Record<string, unknown>): Promise<Memo> {
    return await memos.updateMemo(uuid, data as any);
  },

  async delete(uuid: string): Promise<void> {
    return await memos.deleteMemo(uuid);
  },

  async hardDelete(uuid: string): Promise<void> {
    return await memos.hardDeleteMemo(uuid);
  },

  async restore(uuid: string): Promise<void> {
    await memos.restoreMemo(uuid);
  }
};

// Méthodes
const loadMemos = async (): Promise<void> => {
  loading.value = true;
  try {
    memosData.value = await memosApiService.getAll();
  } catch (error) {
    console.error('Erreur lors du chargement des mémos:', error);
  } finally {
    loading.value = false;
  }
};

const loadUsers = async (): Promise<void> => {
  try {
    users.value = await fetchAllUsers();
  } catch (error) {
    console.error('Erreur lors du chargement des utilisateurs:', error);
  }
};

// Lifecycle
onMounted(async (): Promise<void> => {
  await Promise.all([
    loadMemos(),
    loadUsers()
  ]);
});
</script>